import { buyPdf } from '../services/api';
import { trackPdfPurchaseFailed } from '../services/analytics';

export const buttonHandlers = {

    downloadApp: (context, element) => {

        const email = context.formData?.get('email') ?? 'unknown';
        const link = "https://tryrino.onelink.me/QiRK?af_xp=custom&pid=fnlfx&c=fnlfx&deep_link_value=fnlfox_" + email

        window.location.href = link;
    },

    openLink: (context, element) => {
        if (element.url) {
            window.open(element.url, element.target || '_blank');
        }
    },

    scrollToTop: (context, element) => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        if (element.goToNext !== false) {
            context.goToNextScreen();
        }
    },

    goToScreen: (context, element) => {
        if (element.screenName) {
            console.log(`Navigate to screen: ${element.screenName}`);
            context.goToNextScreen();
        }
    },

    addBookAndContinue: async (context, element) => {

        if (context.setButtonLoading) {
            context.setButtonLoading('addBookAndContinue', true);
        }

        try {
            const paymentProvider = localStorage.getItem('paymentProvider');
            const customerID = localStorage.getItem('customerID');
            const email = context.formData?.get('email');
            const onboardingId = context.onboardingId;

            if (!email) {
                context.goToNextScreen();
                return;
            }

            if (paymentProvider !== 'solidgate' && (!customerID || customerID == undefined)) {
                context.goToNextScreen();
                return;
            }

            const data = await buyPdf(email, onboardingId, paymentProvider);

            if (data.status === 'succeeded' || data.status === 'processing') {
                context.goToNextScreen();
                return;
            } else {
                trackPdfPurchaseFailed({
                    onboardingId,
                    email,
                    paymentProvider,
                    data,
                });
                context.goToNextScreen();
            }
        } finally {
            if (context.setButtonLoading) {
                context.setButtonLoading('addBookAndContinue', false);
            }
        }
    },

};

export const getButtonHandler = (handlerName) => {
    return buttonHandlers[handlerName] || null;
};
